<template>
    <div class="frame-max" :style="{left:(frameNum-1)*width+'px'}">
        <slot></slot>
        <component
            :is="event_type"
            :frameNum="frameNum"
            :title="html_text"
            :multiple_choice="multiple_choice"
            :answersArray="answersArray"
            :testscore="testscore"
            :completionText="completionText"
            :src="video"
            :nextFrame="nextFrame"
            :previousFrame="previousFrame"
            :updateAnswer="updateAnswer"
            :fullTest="fullTest"
            :modules="cards"
        ></component>
        <!-- <button @click="nextF" class="uk-button-primary">NEXT</button> -->
    </div>
</template>


<script>

import VideoContext from './VideoContext.vue'
import TrainingDashboard from './TrainingDashboard.vue'
import Question from './Question.vue'
import TitleFrame from './TitleFrame.vue'
import SubmitAnswers from './SubmitAnswers.vue'
import QuestionsContext from './QuestionsContext.vue'
import CompletionPage from './CompletionPage.vue'
import ThankYouPage from './ThankYou.vue'
export default {
    name: "app-frame",
    components: {
        'multiple_choice': Question,
        'video_player':VideoContext,
        'app-dashboard':TrainingDashboard,
        'html_text': TitleFrame,
        'app-test':QuestionsContext,
        'submit-check':SubmitAnswers,
        'completion-page':CompletionPage,
        'thank-you':ThankYouPage
    },
    props:{
        cards: {
            type: Array,
            default: function(){
                return []
            }
        },
        color: {
            type: String,
            default: "#0044aa"
        },
        frameNum:{
            type: Number,
            default: 0
        },
        item: {
            type: Object
        },
        video: {
            type: String
        },
        multiple_choice: {
            type: Object
        },
        answersArray:{
            type: Array,
            default: function(){
                return []
            }
        },
        fullTest:{
            type:Array,
            default: function(){
                return []
            }
        },
        event_type: {
            type: String
        },
        html_text: {
            type: String
        },
        nextFrame:{
            type: Function
        },
        previousFrame: {
            type: Function
        },
        updateAnswer: {
            type: Function
        },
        checkTest: {
            type: Function
        },
        completionText: {
            type: String,
            default: "Fail"
        },
        testscore: {
            type: Number,
            default: 0
        }
    },
    data: function(){
        return {
            width: window.innerWidth,
        }
    },
    methods: {
        nextF(){
            this.nextFrame(this.frameNum+1)
        }
    }
}

</script>

<style lang="less" scoped>

</style>
